export default __webpack_public_path__ + "static/media/Ok 485_AERIAL.6337d508.jpg";